import { last } from 'rxjs';
import {Component, ViewEncapsulation} from '@angular/core';
import { FieldType, FieldWrapper } from '@ngx-formly/core';
import { FormGroup } from '@angular/forms';
import { AppService } from '../app.service';

import { Capacitor } from "@capacitor/core";
  @Component({
    selector: 'custom-formly-card',
    styles: [`
    .my-card{
      border-radius: 7px;
      margin: 10px 15px;
      padding: 10px;
      display: block;
      position: relative;
    }
    .mt-20{
      margin-top:20px;
    }
      .my-custom-card {
        border-radius: 7px;
        margin: 10px 15px !important;
        padding: 10px;
        display: block;
        position: relative;
      }
      .mb-20{
        margin-bottom:10px;
      }
      .title-text{
        margin-bottom: 10px;
        color: #000;
        font-weight: 600;
        margin-left:20px;
      }
      .mat-tab-label-active{
        background: #C2DDDD;
        color: #007382;
        opacity: 1 !important;
      }
      .mandatory_flag{
        color:red;margin-left:5px
      }
      `],
    template: `
    <div [class]="to.containerClass">
    <ion-row *ngIf="to.title" class="title-text">
      <ion-label> {{to.title | translate}}
      <span *ngIf="to.subtitle"> / {{to.subtitle | translate }}</span></ion-label> <span *ngIf="to.required" class="mandatory_flag">*</span>
    </ion-row>
    <ion-card class="ion-no-margin my-custom-card"  [class]="to.cssClass">
      <ng-container class="house_col_div"  #fieldComponent></ng-container>
    </ion-card>
    </div>`,
    encapsulation: ViewEncapsulation.None,
    standalone: false
}) 
   
  export class CustomFormlyCardType extends FieldWrapper {
    isNativeDevice: boolean = true;
    constructor(private appService: AppService) {
      super();
      this.isNativeDevice = Capacitor.isNativePlatform() ? true: false;
    }
  }
 